import * as Types from '../../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Sat Apr 19 2025 14:34:49 GMT+0000 (Coordinated Universal Time)
*/

const defaultOptions = {} as const;
export type AnonymousAudienceCommentFieldsFragment = { __typename?: 'AnonymousComment', id: string, displayName: string, initials: string, body: string, createdAt: string, updatedAt: string, editedAt?: string | null | undefined, mediaTimestamp?: number | null | undefined, canEdit: boolean, canDelete: boolean };

export type AnonymousTeamCommentFieldsFragment = { __typename?: 'AnonymousTeamComment', id: string, displayName: string, initials: string, body: string, bodyHtml?: string | null | undefined, createdAt: string, updatedAt: string, editedAt?: string | null | undefined, mediaTimestamp?: number | null | undefined, canEdit: boolean, canDelete: boolean };

export type AnonymousMediaFragment = { __typename: 'AnonymousMedia', id: string, hashedId: string, aspectRatio?: number | null | undefined, name: string, description?: string | null | undefined, publicCommentsSelection: Types.PublicCommentsSelection, playerColor: string, mediaType: Types.MediaType, createdByRecord: boolean, hasMediaPage: boolean, hasReadyTimeCodedTranscript: boolean, imageUrl?: string | null | undefined, mediaPage?: { __typename?: 'MediaPage', id: string, hasCustomizations: boolean, customizations: Record<string, any> } | null | undefined, permissionsForCurrentContact: { __typename?: 'MediaPermissions', canDownload: boolean }, topLevelAudienceComments?: { __typename?: 'AnonymousCommentsForMediaConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean }, edges?: Array<{ __typename?: 'AnonymousCommentForMedia', node?: { __typename?: 'AnonymousComment', id: string, displayName: string, initials: string, body: string, createdAt: string, updatedAt: string, editedAt?: string | null | undefined, mediaTimestamp?: number | null | undefined, canEdit: boolean, canDelete: boolean, replies: Array<{ __typename?: 'AnonymousComment', id: string, displayName: string, initials: string, body: string, createdAt: string, updatedAt: string, editedAt?: string | null | undefined, mediaTimestamp?: number | null | undefined, canEdit: boolean, canDelete: boolean }> } | null | undefined } | null | undefined> | null | undefined } | null | undefined, topLevelTeamComments?: { __typename?: 'AnonymousTeamCommentsForMediaConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean }, edges?: Array<{ __typename?: 'AnonymousTeamCommentForMedia', node?: { __typename?: 'AnonymousTeamComment', id: string, displayName: string, initials: string, body: string, bodyHtml?: string | null | undefined, createdAt: string, updatedAt: string, editedAt?: string | null | undefined, mediaTimestamp?: number | null | undefined, canEdit: boolean, canDelete: boolean, replies: Array<{ __typename?: 'AnonymousTeamComment', id: string, displayName: string, initials: string, body: string, bodyHtml?: string | null | undefined, createdAt: string, updatedAt: string, editedAt?: string | null | undefined, mediaTimestamp?: number | null | undefined, canEdit: boolean, canDelete: boolean }> } | null | undefined } | null | undefined> | null | undefined } | null | undefined, account: { __typename?: 'AnonymousAccount', id: string, numericId: number, wistiaBrandingOptional: boolean } };

export type AnonymousMediaQueryVariables = Types.Exact<{
  hashedId: Types.Scalars['HashedId']['input'];
}>;


export type AnonymousMediaQuery = { __typename?: 'Query', anonymousMedia?: { __typename: 'AnonymousMedia', id: string, hashedId: string, aspectRatio?: number | null | undefined, name: string, description?: string | null | undefined, publicCommentsSelection: Types.PublicCommentsSelection, playerColor: string, mediaType: Types.MediaType, createdByRecord: boolean, hasMediaPage: boolean, hasReadyTimeCodedTranscript: boolean, imageUrl?: string | null | undefined, mediaPage?: { __typename?: 'MediaPage', id: string, hasCustomizations: boolean, customizations: Record<string, any> } | null | undefined, permissionsForCurrentContact: { __typename?: 'MediaPermissions', canDownload: boolean }, topLevelAudienceComments?: { __typename?: 'AnonymousCommentsForMediaConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean }, edges?: Array<{ __typename?: 'AnonymousCommentForMedia', node?: { __typename?: 'AnonymousComment', id: string, displayName: string, initials: string, body: string, createdAt: string, updatedAt: string, editedAt?: string | null | undefined, mediaTimestamp?: number | null | undefined, canEdit: boolean, canDelete: boolean, replies: Array<{ __typename?: 'AnonymousComment', id: string, displayName: string, initials: string, body: string, createdAt: string, updatedAt: string, editedAt?: string | null | undefined, mediaTimestamp?: number | null | undefined, canEdit: boolean, canDelete: boolean }> } | null | undefined } | null | undefined> | null | undefined } | null | undefined, topLevelTeamComments?: { __typename?: 'AnonymousTeamCommentsForMediaConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean }, edges?: Array<{ __typename?: 'AnonymousTeamCommentForMedia', node?: { __typename?: 'AnonymousTeamComment', id: string, displayName: string, initials: string, body: string, bodyHtml?: string | null | undefined, createdAt: string, updatedAt: string, editedAt?: string | null | undefined, mediaTimestamp?: number | null | undefined, canEdit: boolean, canDelete: boolean, replies: Array<{ __typename?: 'AnonymousTeamComment', id: string, displayName: string, initials: string, body: string, bodyHtml?: string | null | undefined, createdAt: string, updatedAt: string, editedAt?: string | null | undefined, mediaTimestamp?: number | null | undefined, canEdit: boolean, canDelete: boolean }> } | null | undefined } | null | undefined> | null | undefined } | null | undefined, account: { __typename?: 'AnonymousAccount', id: string, numericId: number, wistiaBrandingOptional: boolean } } | null | undefined, currentUser?: { __typename?: 'User', id: string } | null | undefined };

export type MoreAnonymousTeamCommentsQueryVariables = Types.Exact<{
  cursor?: Types.InputMaybe<Types.Scalars['String']['input']>;
  mediaHashedId: Types.Scalars['HashedId']['input'];
}>;


export type MoreAnonymousTeamCommentsQuery = { __typename?: 'Query', anonymousMedia?: { __typename?: 'AnonymousMedia', id: string, topLevelTeamComments?: { __typename?: 'AnonymousTeamCommentsForMediaConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, edges?: Array<{ __typename?: 'AnonymousTeamCommentForMedia', node?: { __typename?: 'AnonymousTeamComment', id: string, displayName: string, initials: string, body: string, bodyHtml?: string | null | undefined, createdAt: string, updatedAt: string, editedAt?: string | null | undefined, mediaTimestamp?: number | null | undefined, canEdit: boolean, canDelete: boolean, replies: Array<{ __typename?: 'AnonymousTeamComment', id: string, displayName: string, initials: string, body: string, bodyHtml?: string | null | undefined, createdAt: string, updatedAt: string, editedAt?: string | null | undefined, mediaTimestamp?: number | null | undefined, canEdit: boolean, canDelete: boolean }> } | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type MoreAnonymousAudienceCommentsQueryVariables = Types.Exact<{
  cursor?: Types.InputMaybe<Types.Scalars['String']['input']>;
  mediaHashedId: Types.Scalars['HashedId']['input'];
}>;


export type MoreAnonymousAudienceCommentsQuery = { __typename?: 'Query', anonymousMedia?: { __typename?: 'AnonymousMedia', id: string, topLevelAudienceComments?: { __typename?: 'AnonymousCommentsForMediaConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, edges?: Array<{ __typename?: 'AnonymousCommentForMedia', node?: { __typename?: 'AnonymousComment', id: string, displayName: string, initials: string, body: string, createdAt: string, updatedAt: string, editedAt?: string | null | undefined, mediaTimestamp?: number | null | undefined, canEdit: boolean, canDelete: boolean, replies: Array<{ __typename?: 'AnonymousComment', id: string, displayName: string, initials: string, body: string, createdAt: string, updatedAt: string, editedAt?: string | null | undefined, mediaTimestamp?: number | null | undefined, canEdit: boolean, canDelete: boolean }> } | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export const AnonymousAudienceCommentFieldsFragmentDoc = gql`
    fragment anonymousAudienceCommentFields on AnonymousComment {
  id
  displayName
  initials
  body
  createdAt
  updatedAt
  editedAt
  mediaTimestamp
  canEdit
  canDelete
}
    `;
export const AnonymousTeamCommentFieldsFragmentDoc = gql`
    fragment anonymousTeamCommentFields on AnonymousTeamComment {
  id
  displayName
  initials
  body
  bodyHtml
  createdAt
  updatedAt
  editedAt
  mediaTimestamp
  canEdit
  canDelete
}
    `;
export const AnonymousMediaFragmentDoc = gql`
    fragment anonymousMedia on AnonymousMedia {
  __typename
  id
  hashedId
  aspectRatio
  name
  description
  publicCommentsSelection
  playerColor
  mediaType
  createdByRecord
  hasMediaPage
  hasReadyTimeCodedTranscript
  mediaPage {
    id
    hasCustomizations
    customizations
  }
  imageUrl
  permissionsForCurrentContact {
    canDownload
  }
  topLevelAudienceComments {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        ...anonymousAudienceCommentFields
        replies {
          id
          ...anonymousAudienceCommentFields
        }
      }
    }
  }
  topLevelTeamComments {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        ...anonymousTeamCommentFields
        replies {
          id
          ...anonymousTeamCommentFields
        }
      }
    }
  }
  account {
    id
    numericId
    wistiaBrandingOptional
  }
}
    ${AnonymousAudienceCommentFieldsFragmentDoc}
${AnonymousTeamCommentFieldsFragmentDoc}`;
export const AnonymousMediaDocument = gql`
    query AnonymousMedia($hashedId: HashedId!) {
  anonymousMedia(hashedId: $hashedId) {
    id
    ...anonymousMedia
  }
  currentUser {
    id
  }
}
    ${AnonymousMediaFragmentDoc}`;

/**
 * __useAnonymousMediaQuery__
 *
 * To run a query within a React component, call `useAnonymousMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnonymousMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnonymousMediaQuery({
 *   variables: {
 *      hashedId: // value for 'hashedId'
 *   },
 * });
 */
export function useAnonymousMediaQuery(baseOptions: Apollo.QueryHookOptions<AnonymousMediaQuery, AnonymousMediaQueryVariables> & ({ variables: AnonymousMediaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnonymousMediaQuery, AnonymousMediaQueryVariables>(AnonymousMediaDocument, options);
      }
export function useAnonymousMediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnonymousMediaQuery, AnonymousMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnonymousMediaQuery, AnonymousMediaQueryVariables>(AnonymousMediaDocument, options);
        }
export function useAnonymousMediaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnonymousMediaQuery, AnonymousMediaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnonymousMediaQuery, AnonymousMediaQueryVariables>(AnonymousMediaDocument, options);
        }
export type AnonymousMediaQueryHookResult = ReturnType<typeof useAnonymousMediaQuery>;
export type AnonymousMediaLazyQueryHookResult = ReturnType<typeof useAnonymousMediaLazyQuery>;
export type AnonymousMediaSuspenseQueryHookResult = ReturnType<typeof useAnonymousMediaSuspenseQuery>;
export type AnonymousMediaQueryResult = Apollo.QueryResult<AnonymousMediaQuery, AnonymousMediaQueryVariables>;
export const MoreAnonymousTeamCommentsDocument = gql`
    query MoreAnonymousTeamComments($cursor: String, $mediaHashedId: HashedId!) {
  anonymousMedia(hashedId: $mediaHashedId) {
    id
    topLevelTeamComments(first: 50, after: $cursor) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          ...anonymousTeamCommentFields
          replies {
            id
            ...anonymousTeamCommentFields
          }
        }
      }
    }
  }
}
    ${AnonymousTeamCommentFieldsFragmentDoc}`;

/**
 * __useMoreAnonymousTeamCommentsQuery__
 *
 * To run a query within a React component, call `useMoreAnonymousTeamCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoreAnonymousTeamCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoreAnonymousTeamCommentsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      mediaHashedId: // value for 'mediaHashedId'
 *   },
 * });
 */
export function useMoreAnonymousTeamCommentsQuery(baseOptions: Apollo.QueryHookOptions<MoreAnonymousTeamCommentsQuery, MoreAnonymousTeamCommentsQueryVariables> & ({ variables: MoreAnonymousTeamCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MoreAnonymousTeamCommentsQuery, MoreAnonymousTeamCommentsQueryVariables>(MoreAnonymousTeamCommentsDocument, options);
      }
export function useMoreAnonymousTeamCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MoreAnonymousTeamCommentsQuery, MoreAnonymousTeamCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MoreAnonymousTeamCommentsQuery, MoreAnonymousTeamCommentsQueryVariables>(MoreAnonymousTeamCommentsDocument, options);
        }
export function useMoreAnonymousTeamCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MoreAnonymousTeamCommentsQuery, MoreAnonymousTeamCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MoreAnonymousTeamCommentsQuery, MoreAnonymousTeamCommentsQueryVariables>(MoreAnonymousTeamCommentsDocument, options);
        }
export type MoreAnonymousTeamCommentsQueryHookResult = ReturnType<typeof useMoreAnonymousTeamCommentsQuery>;
export type MoreAnonymousTeamCommentsLazyQueryHookResult = ReturnType<typeof useMoreAnonymousTeamCommentsLazyQuery>;
export type MoreAnonymousTeamCommentsSuspenseQueryHookResult = ReturnType<typeof useMoreAnonymousTeamCommentsSuspenseQuery>;
export type MoreAnonymousTeamCommentsQueryResult = Apollo.QueryResult<MoreAnonymousTeamCommentsQuery, MoreAnonymousTeamCommentsQueryVariables>;
export const MoreAnonymousAudienceCommentsDocument = gql`
    query MoreAnonymousAudienceComments($cursor: String, $mediaHashedId: HashedId!) {
  anonymousMedia(hashedId: $mediaHashedId) {
    id
    topLevelAudienceComments(first: 50, after: $cursor) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          ...anonymousAudienceCommentFields
          replies {
            id
            ...anonymousAudienceCommentFields
          }
        }
      }
    }
  }
}
    ${AnonymousAudienceCommentFieldsFragmentDoc}`;

/**
 * __useMoreAnonymousAudienceCommentsQuery__
 *
 * To run a query within a React component, call `useMoreAnonymousAudienceCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoreAnonymousAudienceCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoreAnonymousAudienceCommentsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      mediaHashedId: // value for 'mediaHashedId'
 *   },
 * });
 */
export function useMoreAnonymousAudienceCommentsQuery(baseOptions: Apollo.QueryHookOptions<MoreAnonymousAudienceCommentsQuery, MoreAnonymousAudienceCommentsQueryVariables> & ({ variables: MoreAnonymousAudienceCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MoreAnonymousAudienceCommentsQuery, MoreAnonymousAudienceCommentsQueryVariables>(MoreAnonymousAudienceCommentsDocument, options);
      }
export function useMoreAnonymousAudienceCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MoreAnonymousAudienceCommentsQuery, MoreAnonymousAudienceCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MoreAnonymousAudienceCommentsQuery, MoreAnonymousAudienceCommentsQueryVariables>(MoreAnonymousAudienceCommentsDocument, options);
        }
export function useMoreAnonymousAudienceCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MoreAnonymousAudienceCommentsQuery, MoreAnonymousAudienceCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MoreAnonymousAudienceCommentsQuery, MoreAnonymousAudienceCommentsQueryVariables>(MoreAnonymousAudienceCommentsDocument, options);
        }
export type MoreAnonymousAudienceCommentsQueryHookResult = ReturnType<typeof useMoreAnonymousAudienceCommentsQuery>;
export type MoreAnonymousAudienceCommentsLazyQueryHookResult = ReturnType<typeof useMoreAnonymousAudienceCommentsLazyQuery>;
export type MoreAnonymousAudienceCommentsSuspenseQueryHookResult = ReturnType<typeof useMoreAnonymousAudienceCommentsSuspenseQuery>;
export type MoreAnonymousAudienceCommentsQueryResult = Apollo.QueryResult<MoreAnonymousAudienceCommentsQuery, MoreAnonymousAudienceCommentsQueryVariables>;